export enum DiagnosticVerbosity {
  Normal = 'normal',
  Verbose = 'verbose',
  Trace = 'trace'
}
